/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { withRouter, useHistory, RouteComponentProps } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import AttachmentIcon from "@material-ui/icons/Attachment";
import Delete from "@material-ui/icons/Delete";

import ReCAPTCHA from "core/components/ReCAPTCHA";

import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowBack from "@material-ui/icons/ArrowBack";
import CircularProgress from "@material-ui/core/CircularProgress";

import BackButtonLayout from "core/layouts/backButtonLayout";
import { ErrorComponent } from "core/components/Error";
import { DescreptionText } from "core/components/Text";
import { Row, RowItem } from "core/components/Rows";
import Fail from "pages/Fail";
import {
  toBase64,
  isEmail,
  isMobileAlphanumeric,
  Alphanumeric,
} from "core/utils";

import { CarriersApi } from "api";

import { Inputs, InterestedInTypes, Carrier, Props } from "./modals";
import { useStyles } from "./styles";
import Downarrow from "assets/icons/downarrow";
const recaptchaRef: any = React.createRef();

const Carriers = (
  props: React.PropsWithChildren<Props & RouteComponentProps>
) => {
  const { t, i18n } = useTranslation(["translations"]);
  const win: any = window;
  const langDir = i18n.dir(win["lang"] as string);
  const isRTL = langDir === "rtl";
  const [open, setOpen] = useState(false);
  const [renderError, setRenderError] = useState(false);

  const [attachmentFormatError, setAttachmentFormatError] = useState(false);
  const thanksUrl = win["contactus_thanks_url"];
  const history = useHistory();
  const classes = useStyles();
  const theme = useTheme();
  const {
    register,
    handleSubmit,
    watch,
    errors,
    control,
    setValue,
  } = useForm<Inputs>();
  const {
    compAddress,
    fax,
    interestedIn,
    locale,
    mobile,
    name,
    organization,
    query,
    telephone,
    title,
    email,
  } = watch();

  const [
    interestedInTypes,
    setInterestedInTypes,
  ] = useState<InterestedInTypes>();
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const onChange = (value: any) => {};

  useEffect(() => {
    CarriersApi.getCarrierCatRequest()
      .then((res: any) => {
        console.log(res.data);
        !!res && setInterestedInTypes(res.data);
      })
      .finally(() => console.log(""));
  }, []);

  const onSubmit = async (data: any) => {
    setLoading(true);
    const payload = {
      compAddress: data.compAddress,
      fax: data.fax,
      interestedIn: data.interestedIn,
      locale: i18n.language,
      mobile: data.mobile,
      name: data.name,
      organization: data.organization,
      query: data.query,
      telephone: data.telephone,
      title: data.title,
      email: data.email,
    };

    CarriersApi.postCarrierTypes(payload)
      .then((res: any) => {
        window.sessionStorage.thanksMessage = t("success_message");
        document.location.href = thanksUrl;
      })
      .catch((err) => setRenderError(true))
      .finally(() => setLoading(false));
  };

  return renderError ? (
    <Fail
      hideFail={() => {
        setRenderError(false);
      }}
    ></Fail>
  ) : (
    <BackButtonLayout>
      <Grid container direction="column">
        <Grid item xs={12}>
          <Typography component={"span"} variant={"body2"}>
            <Box
              fontWeight={400}
              style={{
                direction: langDir,
              }}
              className={classes.pageHint}
              mb={theme.spacing(0.5)}
              letterSpacing={1}
            >
              {t("hint")
                .split("\n")
                .map((str) => (
                  <p>{str}</p>
                ))}
            </Box>
          </Typography>
        </Grid>
      </Grid>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <RowItem>
            <Controller
              as={TextField}
              defaultValue={""}
              control={control}
              name="name"
              type={"string"}
              fullWidth
              label={t("form:name")}
              id="name"
              dir={langDir}
              rules={{ required: true, maxLength: 50, pattern: Alphanumeric }}
            />

            <ErrorComponent
              maxLength={50}
              nameLang={t("form:name")}
              patternMessage={t("kindlyUseAlphabeticCharcaters")}
              errors={errors}
              name={"name"}
            />
          </RowItem>
          <RowItem>
            <Controller
              as={TextField}
              defaultValue={""}
              control={control}
              name="title"
              type={"string"}
              rules={{ required: true, maxLength: 50, pattern: Alphanumeric }}
              fullWidth
              label={t("form:title")}
              id="title"
              dir={langDir}
            />
            <ErrorComponent
              maxLength={50}
              nameLang={t("form:title")}
              patternMessage={t("kindlyUseAlphabeticCharcaters")}
              errors={errors}
              name={"title"}
            />
          </RowItem>
        </Row>
        <Row>
          <RowItem>
            <Controller
              as={TextField}
              defaultValue={""}
              control={control}
              name="organization"
              type={"string"}
              rules={{ required: true, maxLength: 50, pattern: Alphanumeric }}
              fullWidth
              label={t("form:organization")}
              id="organization"
              dir={langDir}
            />
            <ErrorComponent
              patternMessage={t("kindlyUseAlphabeticCharcaters")}
              errors={errors}
              nameLang={t("form:organization")}
              name={"organization"}
            />
          </RowItem>
          <RowItem>
            <Controller
              as={
                <TextField
                  color={"secondary"}
                  style={{
                    color: "#000000 !important",
                    textAlign: "right",
                  }}
                  InputProps={{
                    style: {
                      direction: "ltr",
                    },
                    classes: {
                      input: isRTL ? classes.mobileInput : "",
                    },
                  }}
                ></TextField>
              }
              defaultValue={""}
              control={control}
              name="telephone"
              type={"number"}
              rules={{ required: true, maxLength: 15, minLength: 7 }}
              fullWidth
              label={t("form:telephone")}
              id="telephone"
              dir={langDir}
            />
            <div className={classes.customPlaceholder} dir="ltr">
              +966xxxxxxxxx
            </div>
            <ErrorComponent
              maxLength={15}
              minLength={7}
              nameLang={t("form:telephone")}
              errors={errors}
              name={"telephone"}
            />
          </RowItem>
        </Row>

        <Row>
          <RowItem>
            <Controller
              as={
                <TextField
                  style={{
                    color: "black",
                    textAlign: "right",
                  }}
                  InputProps={{
                    style: {
                      direction: "ltr",
                    },
                    classes: {
                      input: isRTL ? classes.mobileInput : "",
                    },
                  }}
                ></TextField>
              }
              defaultValue={""}
              control={control}
              name="mobile"
              type={"string"}
              fullWidth
              label={t("form:mobile")}
              id="mobile"
              dir={"ltr"}
              rules={{
                maxLength: 50,
                minLength: 7,
                pattern: isMobileAlphanumeric,
              }}
            />
            <div className={classes.customPlaceholder} dir="ltr">
              +966xxxxxxxxx
            </div>
            <ErrorComponent
              maxLength={50}
              nameLang={t("form:mobile")}
              patternMessage={t("incorrect_value")}
              errors={errors}
              name={"mobile"}
            />
          </RowItem>
          <RowItem>
            <Controller
              as={TextField}
              defaultValue={""}
              control={control}
              name="fax"
              type={"string"}
              rules={{ maxLength: 50, pattern: Alphanumeric }}
              fullWidth
              label={t("form:fax")}
              id="fax"
              dir={langDir}
            />
            <ErrorComponent
              maxLength={50}
              nameLang={t("form:fax")}
              patternMessage={t("kindlyUseAlphabeticCharcaters")}
              errors={errors}
              name={"fax"}
            />
          </RowItem>
        </Row>

        <Row>
          <RowItem>
            <Controller
              as={TextField}
              defaultValue={""}
              control={control}
              name="email"
              type={"string"}
              fullWidth
              rules={{
                required: true,
                minLength: 7,
                maxLength: 200,
                pattern: isEmail,
              }}
              label={t("form:email")}
              id="email"
              dir={langDir}
            />
            <ErrorComponent
              patternMessage={t("emailPatternError")}
              maxLength={200}
              minLength={7}
              nameLang={t("form:email")}
              errors={errors}
              name={"email"}
            />
          </RowItem>
        </Row>

        <Row>
          <RowItem>
            <Controller
              as={TextField}
              defaultValue={""}
              control={control}
              name="compAddress"
              type={"string"}
              fullWidth
              rules={{
                required: true,
                minLength: 7,
                maxLength: 200,
              }}
              label={t("form:company_address")}
              id="compAddress"
              dir={langDir}
            />
            <ErrorComponent
              maxLength={200}
              minLength={7}
              nameLang={t("form:company_address")}
              errors={errors}
              name={"compAddress"}
            />
          </RowItem>
        </Row>

        <Row>
          <RowItem style={{ width: "calc(50% - 7.5px)", marginTop: 14 }}>
            <InputLabel id="interestedIn">{t("form:interested_in")}</InputLabel>
            <Controller
              as={
                <Select
                  IconComponent={Downarrow}
                  labelId="interestedIn"
                  className={classes.selectService}
                  id="interestedIn"
                  style={{
                    fontSize: "16px",
                    color: "black",
                  }}
                >
                  {interestedInTypes?.carrier_list?.map(
                    (interestedIn: Carrier, index: number) => (
                      <MenuItem
                        key={index}
                        style={{
                          fontSize: "16px",
                          color: "black",
                        }}
                        value={
                          i18n.language == "en"
                            ? interestedIn.id
                            : interestedIn.id
                        }
                      >
                        {i18n.language == "en"
                          ? interestedIn.english_name
                          : interestedIn.arabic_name}
                      </MenuItem>
                    )
                  )}
                </Select>
              }
              defaultValue={""}
              control={control}
              name="interestedIn"
              type={"string"}
              fullWidth
              id="interestedIn"
              dir={langDir}
              open={open}
              onClose={handleClose}
              onOpen={handleOpen}
              rules={{ required: true }}
              // onChange={handleChange}
            />
            <ErrorComponent errors={errors} name={"interestedIn"} />
          </RowItem>
        </Row>

        <DescreptionText
          style={{
            fontSize: theme.spacing(1.75),
          }}
          text={t("how_can_help")}
        />
        <Row>
          <RowItem className={classes.bigTextField}>
            <Controller
              as={TextField}
              defaultValue={""}
              multiline
              rowsMax={4}
              control={control}
              name="query"
              type={"string"}
              fullWidth
              placeholder={t("form:type_message")}
              rules={{ required: true, maxLength: 100 }}
              id="query"
              dir={langDir}
            />
            <ErrorComponent
              maxLength={100}
              nameLang={t("query")}
              errors={errors}
              name={"query"}
            />
            <DescreptionText
              style={{
                fontSize: theme.spacing(1),
                color: "#868D95",
                cursor: "pointer",
                direction: langDir,
              }}
              text={`${String(query).length} ${t("of")} 100`}
            />
          </RowItem>
        </Row>

        <Grid>
          <Button
            onClick={() => {
              if (
                !(
                  Object.keys(errors).length === 0 &&
                  errors.constructor === Object
                )
              ) {
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                return;
              }
            }}
            type="submit"
            variant="contained"
            color="secondary"
            className={classes.button}
            disabled={
              loading ||
              !!!email ||
              !!!telephone ||
              !!!compAddress ||
              !!!interestedIn ||
              !!!name ||
              !!!organization ||
              !!!query ||
              !!!telephone ||
              !!!title
            }
            endIcon={
              !isRTL ? (
                <ArrowForwardIcon
                  style={{ color: "#fff", cursor: "pointer", fontSize: 24 }}
                />
              ) : (
                <ArrowBack
                  style={{ color: "#fff", cursor: "pointer", fontSize: 24 }}
                />
              )
            }
          >
            <Typography component={"span"} variant={"body2"}>
              <Box
                mr={8}
                color={"white"}
                style={{ fontSize: theme.spacing(2), fontWeight: 700 }}
              >
                {t("form:submit")}
              </Box>
            </Typography>
            {loading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </Button>
          <ReCAPTCHA onChange={onChange} recaptchaRef={recaptchaRef} />
        </Grid>
      </form>
    </BackButtonLayout>
  );
};
export default withRouter(Carriers);
